/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

type AudienceSelection = {
  type: string;
  label: string;
  isDisabled: string;
};
interface AudienceSelectionItemArgs {
  item: AudienceSelection;
}

export default class AudienceSelectiontem extends Component<AudienceSelectionItemArgs> {}
